export default __webpack_public_path__ + "static/media/left.c33771c9.dae";